import AccordionContainer from "./AccordionContainer";
import ActionButton from "./ActionButton";
import Avatar from "./Avatar";
import Badge from "./Badge";
import BorderBox from "./BorderBox";
import BottomNavigation from "./BottomNavigation";
import DashboardItem from "./DashboardItem";
import Dialog from "./Dialog";
import Drawer from "./Drawer";
import Dropzone from "./Dropzone";
import IconButton from "./IconButton";
import Image from "./Image";
import ListItem from "./ListItem";
import ListView from "./ListView";
import MobileTableView from "./MobileTableView";
import Modal from "./Modal";
import NavButton from "./NavButton";
import Pill from "./Pill";
import Search from "./Search";
import SnackBarToast from "./SnackbarToast";
import Switch from "./Switch";
import Tab from "./Tab";
import TabBottomNavigation from "./TabBottomNavigation";
import TableActions from "./TableActions";
import TableContainer from "./TableContainer";
import Tabs from "./Tabs";
import Text from "./Text";
import TitleBar from "./TitleBar";

export const Base = {
  AccordionSwitch: AccordionContainer,
  Avatar: Avatar,
  Badge: Badge,
  BorderBox: BorderBox,
  BottomNav: BottomNavigation,
  Button: ActionButton,
  DashboardItem: DashboardItem,
  Dialog: Dialog,
  Drawer: Drawer,
  Dropzone: Dropzone,
  IconButton: IconButton,
  Image: Image,
  ListItem: ListItem,
  ListView: ListView,
  MobileTable: MobileTableView,
  Modal: Modal,
  NavButton: NavButton,
  Pill: Pill,
  Search: Search,
  Switch: Switch,
  Toast: SnackBarToast,
  Tab: Tab,
  TableActions: TableActions,
  TableContainer: TableContainer,
  Tabs: Tabs,
  TabNav: TabBottomNavigation,
  Text: Text,
  TitleBar: TitleBar,
};
